
import * as React from "react";
import { IUser } from "../../../interfaces/IUser";
import { Checkbox } from "../../../../avernus/checkbox/source/Checkbox";
import { Api } from "../../../lib/Api";
import { ReadInputFile } from "../../../../avernus/file/source/ReadInputFile";
import AddMoreComp from "../../global/AddMoreComp";
import ImageUpload from "../../global/ImageUpload";
import LoaderComp from "../../../../avernus/loader/source/LoaderComp";

interface IEditUserProps {
    id                  : number
    urlPrefix           : string
    changed             : Function
    disabledRemoveBtn   ?:boolean
    restaurantId        : number
}

interface ITablePermission{
    id:     number
    name:   string
}

interface IEditUserState {
    success             : string
    error               : string
    form                : IAdminUser
    loading             : boolean
    allTablePermissions : Array<ITablePermission>
    formId              : number
    uploaded_image      : string
}

interface IAdminUser extends IUser{
    tablePermissions    :Array<number>
    removeImageIfExists ?:boolean
    restaurantId        ?:number
}

interface ISaveUser{
    id      ?: number
    success : string
    error   : string
}

interface IOption{
    name: string
    value:string
}

export default class EditUser extends React.Component<IEditUserProps, IEditUserState>{

    private premissionOptions:Array<IOption>;
    private statusOptions:Array<IOption>;

  	constructor(props:IEditUserProps){
        super(props);
        this.premissionOptions = [
            {
                name: 'User',
                value:'user'
            },
            {
                name: 'Manager',
                value:'manager'
            }
        ];
        this.statusOptions = [
            {
                name: 'Active user',
                value:'active'
            },
            {
                name: 'Inactive user',
                value:'inactive'
            }
        ];
        this.state = {
            success                 : null,
            error                   : null,
            form                    : this.props.id === 0?this.createEmptyForm(): null,
            loading                 : this.props.id>0,
            allTablePermissions     : [],
            formId                  : this.props.id,
            uploaded_image          : this.getSampleImageValue()
        };
        this.init();
    }

    private getSampleImageValue(): string {
        return 'img/users/profile_uploader_icon.png';
    }

    private enabledSuperadminPermissonOption():void{
        this.premissionOptions.push({
            name: 'Super Admin',
            value:'superadmin'
        });
    }
    private enabledSimple_operatorPermissonOption():void{
        this.premissionOptions.push({
            name: 'OTP Simple Pperator',
            value:'simple_operator'
        });
    }

    createEmptyForm(): IAdminUser {
        return {
            id                  : 0,
            status              : 'active',
            lastName            : '',
            firstName           : '',
            userName            : '',
            email               : '',
            phone               : '',
            password            : '',
            position            : '',
            permission          : 'user',
            img                 : '',
            tablePermissions    : [],
            photos              : [],
            upload_profile_photo: '',
            type                : 'user'
        };
    }

    private init(){
        if ( this.props.id>0 ) {
            Api.call(this.props.urlPrefix + '/users/getUser', {
                    id          : this.props.id,
                    restaurantId: this.props.restaurantId
                }, (result) =>{
                let form                 = result.form;
                console.log(form);
                if ( result.ownePermission === 'superadmin' || form.permission === 'superadmin' ) {
                    this.enabledSuperadminPermissonOption();
                }
                if ( Api.OTPSimpleModulePermissionEnabled() ) {
                    this.enabledSimple_operatorPermissonOption();
                }
                let tablePermissions:Array<ITablePermission>    = [];
                for (var key in result.tablePermissions) {
                    var item = result.tablePermissions[key];
                    tablePermissions.push(item);
                }


                let uploaded_image          = this.state.uploaded_image;
                if ( form.img !== '' ) {
                    uploaded_image = form.img;
                }

                this.setState({
                    form                   : form,
                    loading                : false,
                    allTablePermissions    : tablePermissions,
                    uploaded_image         : uploaded_image
                });
            } );
        }else{
            this.getAllPermmission();
        }
    }
    private getAllPermmission(){
        Api.call(this.props.urlPrefix + '/users/getAllPermmission', {}, (result) =>{
            if ( result.ownePermission === 'superadmin' ) {
                this.enabledSuperadminPermissonOption();
            }
            if ( Api.OTPSimpleModulePermissionEnabled() ) {
                this.enabledSimple_operatorPermissonOption();
            }
            let tablePermissions:Array<ITablePermission>    = [];
            for (var key in result.tablePermissions) {
                var item = result.tablePermissions[key];
                tablePermissions.push(item);
            }
            this.setState({
                allTablePermissions    : tablePermissions
            });
        } );
    }

    private submitHandler(evt): void {
        if ( evt !== null ) {
            evt.preventDefault();
        }
        let saveUrl:string  = this.props.urlPrefix + (this.props.id>0?'/users/modifyUser':'/users/addUser');
        let saveData        = this.state.form;

        saveData.restaurantId   = this.props.restaurantId;
        Api.call(saveUrl, saveData, (result:ISaveUser)=>{
            this.setState({
                success:    result.success,
                error:      result.error,
                formId:     result.id!==undefined?result.id:0
            }, () =>{
                this.props.changed(false);
            });
        });
    }

    private changeInputHandler(evt, type:string): void {
        evt.preventDefault();
        var form = this.state.form;
        form[type] = evt.target.value;
        this.setState({
            form: form
        });
    }

    private removeBtnClickHandler(evt): void {
        evt.preventDefault();
        if (window.confirm("Are you sure want to delete this  \""+this.state.form.userName+"\" user?")) {
            Api.call(this.props.urlPrefix + '/users/removeUser', {
                id: this.props.id,
                restaurantId: this.props.restaurantId
                }, (result:ISaveUser)=>{
                this.setState({
                    success: result.success,
                    error: result.error
                }, () =>{
                    setTimeout(() => {
                        this.props.changed(true);
                    }, 1000);
                });
            });
        }
    }

    private permissionCheckboxChangeHandler(evt, permissionId:number, saveAfterChange:boolean=false): void {
        if ( evt !== null ) {
            evt.preventDefault();
        }
        let form        = this.state.form;
        if ( form.tablePermissions.indexOf(permissionId) > -1 ) {
            form.tablePermissions.splice(form.tablePermissions.indexOf(permissionId) , 1);
        }else{
            form.tablePermissions.push(permissionId);
        }
        this.setState({
            form: form
        }, ()=>{
            if ( saveAfterChange === true ) {
                this.submitHandler(evt);
            }
        });
    }


    private cancelBtnClickHandler(evt): void {
        evt.preventDefault();
        this.props.changed(true);
    }

    private savePhoto(type, file) {
        let form = this.state.form;
        form[type] = file;
        this.setState({
            form: form
        });

    }


    render() {
        let disabledRemoveBtn = this.props.disabledRemoveBtn !== undefined && this.props.disabledRemoveBtn === true;
        return (
            <>
                { (this.state.loading === true || this.state.form === null)?<div className="loading_row">
                    <LoaderComp show={true} />
                </div>:<>
                    <form onSubmit={ e => this.submitHandler(e) }>
                        <div>
                            <div className="container">
                                <div className="row" style={{marginTop:'10px'}}>
                                    <div className="col-12">
                                        <ImageUpload
                                            id = {'profile_photo'}
                                            label={'Profile photo'}
                                            icon={'/img/upload_photo_icon.png'}
                                            change={(file) => this.savePhoto('upload_profile_photo', file)}
                                            value={this.state.form.photos['profilePhoto'] ?? ''}
                                        />
                                    </div>
                                </div>
                                <div className="row padding">
                                    <div className="col-12">
                                        <div className="form-row">
                                            <div className="col">
                                                <input className="s-form-control" type="text" name="firstName" value={this.state.form.firstName} onChange={ e => this.changeInputHandler(e,'firstName') } placeholder="First name" required={true}/>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="col">
                                                <input className="s-form-control" type="text" value={this.state.form.lastName} onChange={ e => this.changeInputHandler(e,'lastName') }
                                                        name="lastName" placeholder="Last name" required={true} />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="col">
                                                <input className="s-form-control" type="text" placeholder="Position" name="position" value={this.state.form.position} onChange={ e => this.changeInputHandler(e,'position') } />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="col">
                                                <input className="s-form-control" type="text" placeholder="Phone" name="phone" value={this.state.form.phone} onChange={ e => this.changeInputHandler(e,'phone') } />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="col">
                                                <input className="s-form-control" type="text" placeholder="Username" name="userName"  autoComplete="off" value={this.state.form.userName} onChange={ e => this.changeInputHandler(e,'userName') } required={true} />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="col">
                                                <input className="s-form-control" type="email" placeholder="email" name="email"  autoComplete="off" value={this.state.form.email} onChange={ e => this.changeInputHandler(e,'email') } required={true} />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="col">
                                                <input className="s-form-control" placeholder="Password" type="password" name="password" minLength={8} autoComplete="off" value={this.state.form.password} onChange={ e => this.changeInputHandler(e,'password') } required={this.props.id===0}/>
                                            </div>
                                        </div>

                                        <div className="form-row">
                                            <div className="col">
                                                <select className="s-form-control" required={true} name="status"  defaultValue={ this.state.form.status } onChange={ e => this.changeInputHandler(e,'status') }>
                                                    <option value="">--- status ---</option>
                                                    { this.statusOptions.map((item:IOption, key:number) => {
                                                        return <option key={key} value={item.value}>
                                                            { item.name }
                                                        </option>
                                                    })}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="form-row">
                                            <div className="col">
                                                <select className="s-form-control" required={true} name="permission"  defaultValue={ this.state.form.permission } onChange={ e => this.changeInputHandler(e,'permission') }>
                                                    <option value="">--- Permission ---</option>
                                                    { this.premissionOptions.map((item:IOption, key:number) => {
                                                        return <option key={key} value={item.value}>
                                                            { item.name }
                                                        </option>
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div className="grey_section">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-row">
                                        { this.state.allTablePermissions.map((item, index) =>{
                                            let accepted = this.state.form.tablePermissions.indexOf(item.id)>-1?true:false;
                                            return <div key={'checkbox_'+index} className="col-12"  id={'formCheck-'+item.id}>
                                                        <Checkbox
                                                        key={"formCheck-"+ item.id+'_'+(accepted?'1':'0')}
                                                        defaultChecked={ accepted }
                                                        label={ item.name }
                                                        value = "1"
                                                        checkedIconClass="sfc_cb_on"
                                                        notCheckedIconClass="sfc_cb_off"
                                                        onChange = { (checked, value) => {
                                                            this.permissionCheckboxChangeHandler(null, item.id);
                                                        }}
                                                    />
                                                </div>
                                            })
                                        }
                                    </div>
                                    <div className="form-row" style={{
                                        marginTop: '15px'
                                    }}>
                                        <div className="col-sm-12">
                                            { this.state.error !== null?<div className="alert alert-danger">
                                                    { this.state.error }
                                            </div>:''}
                                            { this.state.success !== null?<div className="alert alert-success">
                                                    { this.state.success }
                                            </div>:''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="white_section_2">
                            <div className="row">
                                <div className="col-12 mb-5">
                                    <button className="purple_btn" id="user_save_btn" type="submit">Save</button>
                                </div>
                                <div className="col-12">
                                    { (this.props.id > 0 && disabledRemoveBtn === false ) ?<button style={{ marginRight: '10px' }} className="red_btn" id="user_remove_btn" type="button" onClick={ e => this.removeBtnClickHandler(e) }
                                    >Remove</button>:'' }
                                </div>
                            </div>
                        </div>


                        <input type="hidden" id="form_id" value={this.state.formId} />
                    </form>
                    { (this.state.formId !== 0 && this.haveMoreRestaurants()  )?<div className="connet_restaurant_to_user_comp">
                        <legend>Restaurants:</legend>
                        <AddMoreComp
                            key={this.state.formId}
                            id={this.state.formId}
                            xhrGetListForSelect={this.props.urlPrefix +"/service/getListForAutoComplete"}
                            xhrGetItems={this.props.urlPrefix +"/user/getConnectedRestaurant"}
                            xhrAdd={this.props.urlPrefix +"/user/addRestaurant"}
                            xhrRemove={this.props.urlPrefix +"/user/removeRestaurant"}
                        />
                    </div>:'' }
                    <div className = "back-btn">
                        <button type="button" className="back_btn" onClick={ e => this.cancelBtnClickHandler(e) }>Back to users</button>
                    </div>
                </> }


            </>
        );
    }

    private haveMoreRestaurants():boolean{
        if ( this.props.restaurantId !== null ) {
            if ( Api.getRestaurants().length > 1 ) {
                return true;
            }
            return false;
        }else{
            return true;
        }
    }
}
